/**
 * LP SOURCE TRACKER v2 (last-click entre LPs)
 *
 * Marca o cart com `_lp_source = <nome-da-LP>` quando o cliente está numa LP
 * instrumentada. O atributo viaja nativamente do cart → checkout → order, então
 * conseguimos atribuir receita pra LP via Admin API (order.note_attributes).
 *
 * Como ativar: na section da LP, adicionar ANTES desta tag:
 *   <script>window.__lpSource = 'monta-que-desconta';</script>
 *   <script src="{{ 'lp-source-tracker.js' | asset_url }}" defer></script>
 *
 * Sem __lpSource definido, o script não faz NADA.
 *
 * Modelo de atribuição: LAST-CLICK ENTRE LPs (mudou em 20/Mai/2026).
 * Se o user passa por LP A → LP B → checkout, ganha LP B.
 * Se o user passa pela mesma LP várias vezes, é no-op (idempotência via comparação de valor).
 *
 * Decisões importantes:
 * - NÃO intercepta window.fetch (evita conflito com ecobag-gift.js que já intercepta)
 * - Marca requests próprias com header X-LP-Tracker pra outros scripts ignorarem se quiserem
 * - Sobrescreve o attribute se o valor for diferente (last-click), skip se for igual
 * - Falha silenciosa: try/catch em tudo, jamais quebra a LP
 * - Cookie de fallback dura 30 dias — sobrevive a cart vazio/clear (sempre atualizado)
 */
(function () {
  'use strict';

  // Bail completamente se a LP não definiu __lpSource — script vira no-op
  var SOURCE = window.__lpSource;
  if (!SOURCE || typeof SOURCE !== 'string') return;

  var ATTR_KEY = '_lp_source';
  var COOKIE_KEY = 'lp_source';
  var COOKIE_DAYS = 30;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // ── Helpers ──────────────────────────────────────────────────────────

  function safe(fn) {
    return function () {
      try { return fn.apply(null, arguments); }
      catch (e) { /* silencioso por design */ }
    };
  }

  function setCookie(name, value, days) {
    try {
      var expires = new Date(Date.now() + days * 86400000).toUTCString();
      document.cookie = name + '=' + encodeURIComponent(value) +
        '; expires=' + expires + '; path=/; SameSite=Lax';
    } catch (e) {}
  }

  function getCookie(name) {
    try {
      var match = document.cookie.match(new RegExp('(^|;\\s*)' + name + '=([^;]*)'));
      return match ? decodeURIComponent(match[2]) : null;
    } catch (e) { return null; }
  }

  function getCart() {
    return fetch(ROOT + 'cart.js', {
      headers: { 'Accept': 'application/json', 'X-LP-Tracker': '1' }
    }).then(function (r) { return r.json(); });
  }

  function updateAttribute(value) {
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-LP-Tracker': '1'
      },
      body: JSON.stringify({
        attributes: (function () {
          var a = {}; a[ATTR_KEY] = value; return a;
        })()
      })
    });
  }

  // ── Core ─────────────────────────────────────────────────────────────

  var applyAttribute = safe(function () {
    // Idempotência: se já chamamos nesta página, skip
    if (window.__lpSourceTrackerApplied) return;
    window.__lpSourceTrackerApplied = true;

    // 1. Sempre seta o cookie (sobrevive a cart vazio)
    setCookie(COOKIE_KEY, SOURCE, COOKIE_DAYS);

    // 2. Last-click: sobrescreve o attribute se for diferente. Idempotência só pro
    //    caso de "mesma LP" (evita request inútil no F5). Se LP é OUTRA, atualiza.
    getCart().then(function (cart) {
      try {
        var current = cart && cart.attributes && cart.attributes[ATTR_KEY];
        if (current === SOURCE) return; // já marcado COM ESTA LP — nada a fazer
        return updateAttribute(SOURCE); // outra LP (ou vazio) → sobrescreve
      } catch (e) {}
    }).catch(function () { /* silencioso */ });
  });

  // ── Init ─────────────────────────────────────────────────────────────

  // Tier 1: aplica logo. defer já garante DOM, então não precisa esperar.
  // Mas damos uma folga de 500ms pra deixar outros scripts (ecobag-gift) iniciarem
  // o fetch interceptor primeiro — assim nossas requests entram já interceptáveis.
  setTimeout(applyAttribute, 500);
})();
